import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from './useAppDispatch';
import { selectUser } from 'shared/selectors/user';
import { setModalContent } from 'shared/slices';
import { setDoorCompleted } from 'shared/thunks';
import { EAdventDoorsHashs } from 'shared/types/doors';
import { findDoorId } from 'shared/utils/findDoorId';

interface IUseDoorContentParams {
  doorCode: EAdventDoorsHashs;
  giftLink?: string;
}

interface IUseDoorContentReturn {
  handleClickBtn: () => Promise<void>;
  isDoorCompleted?: boolean;
  isLoading: boolean;
}

export const useDoorContent = ({ doorCode, giftLink }: IUseDoorContentParams): IUseDoorContentReturn => {
  const dispatch = useAppDispatch();
  const { user } = useSelector(selectUser);

  const doorId = useMemo(() => findDoorId(doorCode), [doorCode]);

  const [isLoading, setIsLoading] = useState(false);

  const isDoorCompleted = useMemo(
    () => Boolean(user?.doors.find(item => item.id === doorId)?.status),
    [user?.doors, doorId],
  );

  const handleClickBtn = useCallback(async () => {
    setIsLoading(true);
    if (!isDoorCompleted) {
      await dispatch(setDoorCompleted({ doorCode }));
    }
    setIsLoading(false);

    dispatch(setModalContent(null));

    if (giftLink) {
      window.open(giftLink, '_blank');
    }
  }, [dispatch, doorCode, giftLink, isDoorCompleted]);

  return {
    handleClickBtn,
    isDoorCompleted,
    isLoading,
  };
};
